module.exports = __webpack_public_path__ + "static/media/bg-step-current-1.c4063b70.png";